import { render, staticRenderFns } from "./LoginOrRegist.vue?vue&type=template&id=3d9cd78a&scoped=true"
import script from "./LoginOrRegist.vue?vue&type=script&lang=ts"
export * from "./LoginOrRegist.vue?vue&type=script&lang=ts"
import style0 from "./LoginOrRegist.scss?vue&type=style&index=0&id=3d9cd78a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9cd78a",
  null
  
)

export default component.exports